import * as actions from './actions'

export default {
    namespaced: true,    
    actions,    
}